<template>
    <a-spin :spinning="!showEditor">
        <div :id="eleId" :class="{'md-disabled':disabled}"/>
    </a-spin>
</template>

<script>
import {onBeforeUnmount, onMounted, ref, toRefs, watch} from "vue";
import Editor from "@toast-ui/editor";
// import "codemirror/lib/codemirror.css";
import "@toast-ui/editor/dist/toastui-editor.css";
// import "@toast-ui/editor/dist/theme/toastui-editor-dark.css";
import "@toast-ui/editor/dist/i18n/zh-cn";
import axios from "axios";
import Message from "ant-design-vue/lib/message"
import {file_service} from "@/api/adminService";

const defaultOptions = {
    height: "500px",
    initialEditType: "markdown",
    previewStyle: "vertical",
    language: "zh-CN",
    useCommandShortcut: true,
    hideModeSwitch: false,
    hooks: {
        addImageBlobHook: (file, callback) => {
            let formData = new FormData();
            formData.append("file", file);
            axios({
                method: "get",
                url: file_service.upload,
                data: formData,
            }).then((res) => {
                let {code = "200", data = {}, msg = "ok"} = res.data;
                if (code === "00000") {
                    callback("/resources" + data.fileAddr, data.fileName)
                } else {
                    Message.warn(msg);
                }
            }).catch(() => {
                Message.warn("上传错误");
            });
        }
    }
};

export default {
    name: "MarkdownEditor",
    props: {
        value: {
            type: String,
            default: "",
        },
        options: {
            type: Object,
            default() {
                return {};
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    emits: [
        "change",
        "update:value"
    ],
    setup(props, {emit}) {
        const showEditor = ref(false);
        const eleId = ref(`markdown-editor-${new Date().getTime()}_${(Math.random() * 1000).toFixed(0)}`);
        const editor = ref(null);

        const initEditor = () => {
            if (props.disabled) {
                editor.value = new Editor.factory({
                    el: document.getElementById(eleId.value),
                    viewer: true,
                    initialValue: props.value || "",
                });
            } else {
                editor.value = new Editor({
                    el: document.getElementById(eleId.value),
                    ...Object.assign({}, defaultOptions, props.options),
                    initialValue: props.value || "",
                    events: {
                        change: () => {
                            const value = getValue();
                            emit("change", value);
                            emit("update:value", value);
                        }
                    }
                });
            }
        }

        const getValue = () => {
            return editor.value.getMarkdown();
        }
        const setValue = (value) => {
            window.console.log('setValue', value)
            // editor.value.setMarkdown(value);
            editor.value.destroy();
            initEditor();
        }

        const getHTML = () => {
            return editor.value.getHTML();
        }
        const setHTML = (value) => {
            window.console.log('setHTML', value)
            // editor.value.setHTML(value);
            editor.value.destroy();
            initEditor();
        }

        const {value} = toRefs(props);
        watch(value, (newValue, preValue) => {
            if (newValue !== preValue && (props.disabled ? true : newValue !== getValue())) {
                setValue(newValue);
            }
        })

        onMounted(() => {
            showEditor.value = true;
            initEditor();
        })
        onBeforeUnmount(() => {
            if (!editor.value) {
                return false;
            }
            editor.value.destroy();
        })

        return {
            showEditor,
            eleId,
            editor,
            setHTML,
            getHTML,
        }
    },
};
</script>
<style lang="less" scoped>
.md-disabled {
  padding: 25px;
}
</style>
